/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { request } from '@mairistem/tools';

// Hook pour mettre à jour un individu brouillon
const useUpdateIndividu = () => {
  const [loading, setLoading] = React.useState(false);

  // Met à jour le flag isBrouillon d'un individu

  const updateIndividu = React.useCallback((identifiant: number | string) => {
    setLoading(true);

    return request
      .patch(`/api/administres/recensement-citoyen/individus/${identifiant}`, {
        isBrouillon: false,
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Met à jour un individu brouillon déjà généré
  const updateIndividuBrouillon = React.useCallback(
    (identifiant: number | string, individu: any) => {
      setLoading(true);

      // Exclure les champs qui ne doivent pas être envoyés
      const { notice, teledossierData, ...payload } = individu;

      return request
        .patch(
          `/api/administres/recensement-citoyen/individus/${identifiant}`,
          {
            ...payload,
            isBrouillon: true,
          },
        )
        .finally(() => {
          setLoading(false);
        });
    },
    [],
  );

  return { updateIndividu, updateIndividuBrouillon, loading };
};

export default useUpdateIndividu;
